<template>
  <div>
    <div ref="pageTopAnchor" style="height:80px;margin-top:-80px;"></div>
    <div class="ceiling">
      <home-top></home-top>
      <!-- 头部导航栏 -->
      <top-search :showHot="true" type="home"></top-search>
      <navicat :current="1" background="#fff"></navicat>
    </div>
    <!-- <div class="h-top"></div> -->

    <!-- 身体内容 -->
    <div class="content w-1400">
      <div class="bread-crumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>试剂商城</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 头部搜索 -->
      <div class="content-search">
        <div class="content-search-box">
          <el-input placeholder="请输入内容" v-model="keyword" @input="onSearchInput">
            <el-button slot="append" icon="el-icon-search" class="search-btn" @click="searchList">搜索</el-button>
          </el-input>
        </div>
        <el-button type="primary" @click="handleCar" class="car-btn">
          <img src="../../static/index/shop/icon-car.png" alt="购物车图片" class="car-img"/>
          购物车
        </el-button>
      </div>
      <classfily :loading="loading" :data="mallCategoryList" @changeClassify="changeClassify"></classfily>


      <!-- 商品列表 -->
      <div class="content-list">
        <div class="content-list-left">
          <div class="goods-box" v-if="loadingList">
            <el-skeleton v-for="i in 12" :key="i" style="width: 330px;border: 1px solid #e7eaf3" animated>
              <template slot="template">
                <el-skeleton-item variant="image" style="width: 330px; height: 180px;"/>
                <div style="padding: 14px;border-bottom:1px solid #e7eaf3 ;">
                  <el-skeleton-item variant="p" style="width: 100%;height: 28px"/>
                  <el-skeleton-item variant="caption" style="width: 100px; height:14px;display: block;margin: 8px 0;"/>
                  <el-skeleton-item variant="caption"
                                    style="width: 100px; height:14px;display: block;margin-bottom: 8px;"/>
                </div>
                <div style="padding:14px">
                  <el-skeleton-item variant="p" style="width: 100px;height: 28px"/>
                  <div style="display: flex;justify-content:space-between">
                    <el-skeleton-item variant="caption" style="width: 100px; height:28px;display: block;"/>
                    <el-skeleton-item variant="caption" style="width: 100px; height:28px;display: block;"/>
                  </div>
                </div>
              </template>
            </el-skeleton>
          </div>
          <div class="goods-box" v-else>
            <shop-default v-for="(item, index) in productList" :key="index" :data="item"></shop-default>
            <empty v-if="productList.length === 0"></empty>
          </div>
          <!--           分页 -->
          <div class="pagination-box" v-if="productList.length >= 20">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
                           :page-sizes="[21, 42, 84, 100]" :page-size="pageSize" background
                           layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
          </div>
        </div>
        <div class="content-list-right">
          <div class="content-list-right-box">
            <div class="title">优质供应商</div>
            <div class="title-desc">QUALITY SUPPLIERS</div>
          </div>
          <div class="contnt-list-right-inner">
            <div v-for="i in goodSupplierList" :key="i.id" class="right-item">
              <img :src="i.image" alt=""/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <home-footer></home-footer>

  </div>
</template>
<script>
import homeTop from "@/components/public/home-top.vue";
import homeFooter from "@/components/public/home-footer.vue";
import shopDefault from "@/components/goods/shop-default.vue";
import navicat from "@/components/navicat/navicat.vue";
import classfily from "@/components/public/classfily.vue";
import empty from "@/components/public/empty.vue";
import {
  getMallCategoryListAtApi,
  getGoodSupplierList,
  listApi,
  shop_cart_list,
} from "@/api/modules/home";
import TopSearch from "../../components/public/top-search.vue";

export default {
  components: {TopSearch, homeTop, homeFooter, shopDefault, navicat, classfily, empty},

  data() {
    return {
      pageSize: 21,
      pageNum: 1,
      total: 0,
      currentPage4: 1,
      shopList: [],
      productList: [],
      activeIndex: 1,
      keyword: "",
      goodSupplierList: [],
      mallCategoryList: [],
      loading: false,
      loadingList: false,
      classId: "",
      carNum: 0,
    };
  },
  computed: {
    isLogin() {
      return this.$store.getters.isLogin;
    },
    isVip() {
      return this.$store.getters.is_vip;
    }
  },
  watch: {
    isLogin(newVal) {
      if (newVal) {
        this.getCarNum();
      }
    },
  },
  created() {
    this.getMallCategoryList();
    this.getGoodSupplier();
    this.getProductList();
  },
  methods: {
    onSearchInput(e) {
      if (!e.trim()) {
        this.searchList()
      }
    },
    searchList() {
      this.page = 1
      this.productList = []
      this.getProductList()
    },
    // 获取购物车数量
    getCarNum() {
      shop_cart_list().then((res) => {
        this.carNum = res.data.data.total;
      });
    },
    // 选择分类
    changeClassify(id) {
      this.classId = id;
      this.getProductList();
    },
    // 获取商品列表
    getProductList() {
      this.loadingList = true;
      listApi({
        cate_id: this.classId,
        page: this.pageNum,
        limit: this.pageSize,
        keywords: this.keyword
      }).then((res) => {
        this.productList = res.data.data.data;
        this.total = res.data.data.total;
        this.loadingList = false;
      });
    },
    // 获取优质供应商
    getGoodSupplier() {
      getGoodSupplierList().then((res) => {
        this.goodSupplierList = res.data.data.data;
      });
    },
    // 获取商城分类
    getMallCategoryList() {
      this.loading = true;
      getMallCategoryListAtApi().then((res) => {
        this.mallCategoryList = res.data.data;
        this.loading = false;
      });
    },
    // 修改页数
    handleSizeChange(val) {
      this.pageSize = val;
      this.getProductList();
    },
    // 下一页
    handleCurrentChange(val) {
      this.pageNum = val;
      this.$refs.pageTopAnchor?.scrollIntoView({behavior: 'auto', block: 'start'})
      this.getProductList();
    },
    // 购物车
    handleCar() {
      if (!this.isLogin) {
        this.$confirm("请先登录", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$router.push("/login");
        });
        return;
      }
      this.$router.push("/shop/car");
    },
  },
};
</script>
<style lang="scss" scoped>
.h-top {
  // height: 95px;
  //height: 80px;
  //height: 225px;
  height: 265px;
}


.bread-crumb {
  margin: 20px 0;
}

.content {
  margin-bottom: 50px;
}

.content-search {
  display: flex;
  align-items: center;
  margin: 20px auto;

  .car-btn {
    background: #ff7902;
    border: none;
    height: 50px;
    font-size: 16px;
    margin-left: 28px;

    .car-img {
      width: 15px;
      height: 15px;
      vertical-align: middle;
    }
  }

  .content-search-box {
    width: 932px;
    height: 50px;

    .search-btn {
      width: 141px;
      height: 50px;
      background: #4B87FF;
      border-radius: 0px 6px 6px 0px;
      text-align: center;
      font-size: 16px;
      // line-height: 63px;
      color: #fff;
    }

    ::v-deep .el-input__inner {
      height: 50px !important;
    }

    ::v-deep .el-input {
      height: 50px !important;
    }
  }
}

.content-list {
  display: flex;
  margin: 20px 0;

  .content-list-left {
    width: 1091px;
    // height: 2647px;
    background: #ffffff;
    border-radius: 6px 6px 6px 6px;
    margin-right: 24px;
    padding: 30px;
    box-sizing: border-box;

    .goods-box {
      display: flex;
      //justify-content: space-between;
      flex-wrap: wrap;
      gap: 17px;
      // margin-bottom: 20px;
    }

    .pagination-box {
      padding-top: 50px;
      text-align: center;
    }
  }

  .content-list-right {
    width: 285px;
    // height: 2647px;
    background: #ffffff;
    border-radius: 6px 6px 6px 6px;

    .content-list-right-box {
      padding: 20px 20px 10px;

      .title {
        font-weight: bold;
        font-size: 24px;
        color: #00112b;
      }

      .title-desc {
        font-weight: 500;
        font-size: 12px;
        color: #5f616c;
      }
    }

    .contnt-list-right-inner {
      padding: 0 10px;

      .right-item {
        width: 265px;
        height: 120px;
        text-align: center;
        background: #ffffff;
        border-radius: 0px 0px 0px 0px;
        margin-bottom: 20px;

        &:last-child {
          margin-bottom: 0;
        }

        img {
          width: 80%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
  }
}
</style>
